<template>
	<div class="color-picker" :class="{ [`color-picker-${id}`]: true, 'is-open': isShowPicker, 'is-disabled': disabled }">
		<v-menu v-model="isShowPicker" bottom content-class="picker-layout" :close-on-content-click="false">
			<template #activator="{ on, attrs }">
				<div v-on="on" v-bind="attrs" class="toggle-button-container" :style="{ background: localColor }">
					<div class="toggle-button"><AppIcon :name="iconName" /> <AppIcon :name="'tiny-triangle'" /></div>
				</div>
			</template>
			<div class="picker-header">
				<div>{{ title }}</div>
				<div @click="isShowPicker = false" class="close-x"></div>
			</div>
			<InputColorPicker :color.sync="localColor" :enableTransparent="enableTransparent" />
		</v-menu>
	</div>
</template>

<script>
import { v4 as uuid } from 'uuid';
import InputColorPicker from '../InputColorPicker';

export default {
	name: 'ColorPicker',
	components: {
		InputColorPicker,
	},
	props: {
		title: { type: String, default: '' },
		color: { type: [String, Object] },
		iconName: { type: String },
		enableTransparent: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
	},
	computed: {
		localColor: {
			set(value) {
				this.$emit('update:color', value);
			},
			get() {
				return this.color;
			},
		},
	},
	methods: {},
	watch: {},
	data() {
		return {
			id: uuid(),
			isShowPicker: false,
		};
	},
};
</script>

<!-- remove global style from here when done -->
<style scoped lang="scss">
@import '@/styles/utility-classes/picker-layout.scss';
.picker-layout {
	padding: 10px;
}
.color-picker {
	$disabled-border: #dfe2e8;
	$width: 36px;

	width: ($width + 2px);
	margin-top: -5px;
	z-index: $z-index-2;
	transition: 0.2s;

	&.is-open {
		z-index: $z-index-3;
	}

	&.is-disabled {
		.toggle-button-container,
		.toggle-button {
			background-color: var(--disabled-color);
			border-color: var(--disabled-color);
			pointer-events: none;

			::v-deep svg path {
				fill: $disabled-border;
			}
		}
		.toggle-button {
			z-index: -1;
		}
		.toggle-button-container {
			background-color: var(--disabled-color) !important;
			border-color: $disabled-border;
		}
	}

	.toggle-button-container {
		position: relative;
		height: 5px !important;
		width: 19px !important;
		transition: all 0.15s;
		border: none;
		overflow: visible;
		border-radius: 0 !important;
		border: 1px solid var(--forth-text-color);
		box-sizing: border-box;
		margin: 22px 0 0 7px;

		.toggle-button {
			position: absolute;
			bottom: -10px !important;
			right: -7px !important;
			height: $width;
			width: $width;
			transform: translate(3px, -4px);
			border: var(--primary-border);
			border-radius: var(--border-radius);
			padding: 5px 10px 10px 8px;
			filter: brightness(85%);
			cursor: pointer;
			transition: 0.2s;

			&:hover {
				filter: brightness(20%);
				transition: 0.2s;
			}

			> :nth-child(1) {
				margin: 0px 0px 15px 0;
			}
			> :nth-child(2) {
				transform: translate(24px, -20px);
			}
		}

		::v-deep svg path {
			fill: var(--third-text-color);
		}
	}
}
</style>
